<template>
  <b-modal :title="`Add Location`" size="lg" v-model="visible" @ok="save" @cancel="hide" ok-title="Save" :ok-disabled="!canSave || saving">
    <b-row>
      <b-col cols="12">
        <b-form-group>
          <label for="name">Name</label>
          <b-form-input type="text" id="name" placeholder="Enter your location name" v-model="location.name" required></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group>
          <label for="street">Street</label>
          <b-form-input type="text" id="street" placeholder="Enter street name" v-model="location.address.street"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group>
          <label for="street2">Street 2 (Suite, Apt, etc)</label>
          <b-form-input type="text" id="street2" placeholder="Enter additional street info" v-model="location.address.street2"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group>
          <label for="country">Country</label>
          <b-form-select v-model="location.address.country">
            <b-form-select-option value="USA">United States of America</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group>
          <label for="city">City</label>
          <b-form-input type="text" id="city" placeholder="Enter your city" v-model="location.address.city"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group>
          <label for="state">State</label>
          <b-form-select v-model="location.address.state">
            <b-form-select-option label="Alabama" value="AL">Alabama</b-form-select-option><b-form-select-option label="Alaska" value="AK">Alaska</b-form-select-option><b-form-select-option label="Arizona" value="AZ">Arizona</b-form-select-option><b-form-select-option label="Arkansas" value="AR">Arkansas</b-form-select-option><b-form-select-option label="California" value="CA">California</b-form-select-option><b-form-select-option label="Colorado" value="CO">Colorado</b-form-select-option><b-form-select-option label="Connecticut" value="CT">Connecticut</b-form-select-option><b-form-select-option label="Delaware" value="DE">Delaware</b-form-select-option><b-form-select-option label="District of Columbia" value="DC">District of Columbia</b-form-select-option><b-form-select-option label="Florida" value="FL">Florida</b-form-select-option><b-form-select-option label="Georgia" value="GA">Georgia</b-form-select-option><b-form-select-option label="Hawaii" value="HI">Hawaii</b-form-select-option><b-form-select-option label="Idaho" value="ID">Idaho</b-form-select-option><b-form-select-option label="Illinois" value="IL">Illinois</b-form-select-option><b-form-select-option label="Indiana" value="IN">Indiana</b-form-select-option><b-form-select-option label="Iowa" value="IA">Iowa</b-form-select-option><b-form-select-option label="Kansas" value="KS">Kansas</b-form-select-option><b-form-select-option label="Kentucky" value="KY">Kentucky</b-form-select-option><b-form-select-option label="Louisiana" value="LA">Louisiana</b-form-select-option><b-form-select-option label="Maine" value="ME">Maine</b-form-select-option><b-form-select-option label="Maryland" value="MD">Maryland</b-form-select-option><b-form-select-option label="Massachusetts" value="MA">Massachusetts</b-form-select-option><b-form-select-option label="Michigan" value="MI">Michigan</b-form-select-option><b-form-select-option label="Minnesota" value="MN">Minnesota</b-form-select-option><b-form-select-option label="Mississippi" value="MS">Mississippi</b-form-select-option><b-form-select-option label="Missouri" value="MO">Missouri</b-form-select-option><b-form-select-option label="Montana" value="MT">Montana</b-form-select-option><b-form-select-option label="Nebraska" value="NE">Nebraska</b-form-select-option><b-form-select-option label="Nevada" value="NV">Nevada</b-form-select-option><b-form-select-option label="New Hampshire" value="NH">New Hampshire</b-form-select-option><b-form-select-option label="New Jersey" value="NJ">New Jersey</b-form-select-option><b-form-select-option label="New Mexico" value="NM">New Mexico</b-form-select-option><b-form-select-option label="New York" value="NY">New York</b-form-select-option><b-form-select-option label="North Carolina" value="NC">North Carolina</b-form-select-option><b-form-select-option label="North Dakota" value="ND">North Dakota</b-form-select-option><b-form-select-option label="Ohio" value="OH">Ohio</b-form-select-option><b-form-select-option label="Oklahoma" value="OK">Oklahoma</b-form-select-option><b-form-select-option label="Oregon" value="OR">Oregon</b-form-select-option><b-form-select-option label="Pennsylvania" value="PA">Pennsylvania</b-form-select-option><b-form-select-option label="Puerto Rico" value="PR">Puerto Rico</b-form-select-option><b-form-select-option label="Rhode Island" value="RI">Rhode Island</b-form-select-option><b-form-select-option label="South Carolina" value="SC">South Carolina</b-form-select-option><b-form-select-option label="South Dakota" value="SD">South Dakota</b-form-select-option><b-form-select-option label="Tennessee" value="TN">Tennessee</b-form-select-option><b-form-select-option label="Texas" value="TX">Texas</b-form-select-option><b-form-select-option label="Utah" value="UT">Utah</b-form-select-option><b-form-select-option label="Vermont" value="VT">Vermont</b-form-select-option><b-form-select-option label="Virginia" value="VA">Virginia</b-form-select-option><b-form-select-option label="Washington" value="WA">Washington</b-form-select-option><b-form-select-option label="West Virginia" value="WV">West Virginia</b-form-select-option><b-form-select-option label="Wisconsin" value="WI">Wisconsin</b-form-select-option><b-form-select-option label="Wyoming" value="WY">Wyoming</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group>
          <label for="postal-code">Postal Code</label>
          <b-form-input type="text" id="postal-code" placeholder="Postal Code" v-model="location.address.zipcode"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group>
          <b-checkbox v-model="location.e911">e911</b-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <b-checkbox v-model="location.default">Default</b-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    canSave () {
      if (this.location && this.location.address && this.location.name && this.location.address.street) {
        return true
      }
      return false
    },
    ...mapGetters({
      account: 'global/account'
    }),
  },
  data () {
    return {
      visible: false,
      saving: false,
      location: {
        name: null,
        e911: false,
        default: false,
        address: {
          id: null,
          street: null,
          street2: null,
          city: null,
          state: null,
          zipcode: null,
          country: 'USA'
        }
      }
    }
  },
  methods: {
    async save () {
      this.saving = true
      this.location.accountId = this.account.id
      const { data } = await this.$axios.post(`/v1/locations`, this.location)
      this.saving = false
      this.$emit('add', data)
    },
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  },
  mounted () {
    this.$bus.$on('modal:addLocation', () => {
      this.show();
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal:addLocation')
  }
}
</script>
